<template>
<v-card height="100%" color="secondary">
    <v-overlay absolute :opacity=".7" v-model="disabled" />
    <v-card-title class="pb-1">{{$style.label.full(name)}}</v-card-title>
    <v-card-text class="pb-1" v-if="valid">
        <v-checkbox
            class="mt-0"
            v-if="containsKey(data, 'enable')"
            :label="$t('Enable')" 
            v-model="data.enable"
        ></v-checkbox>
        <v-text-field
            :label="$t('Set Value')"
            v-model.number="data.set_value"
            type="number"
            :rules="rangeCheck(data.range)"
            :suffix="units"
        ></v-text-field>
    </v-card-text>
    <v-card-actions class="pt-0" v-if="showActions">
        <v-spacer></v-spacer>
        <v-btn text @click="close">{{$t('Close')}}</v-btn>
        <v-btn @click="apply" color="primary">{{$t('Apply')}}</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import { rangeCheck } from '@/services/Utils.js';

export default {
    props: {
        data: { type: Object, required: true },
        name: { type: String, required: true},
        valid: { type: Boolean, required: true },
        showActions: { type: Boolean, default: false },
        disabled: {type: Boolean, default: false}
    },
    computed: {
        units () { return this.$store.state.conditions.data[this.name].units; }
    },
    methods: {
        rangeCheck,
        containsKey (obj, key) { return Object.keys(obj).includes(key); },
        close () { this.$emit('close') },
        apply () { this.$emit('apply') }
    }
}
</script>

<style scoped>
::v-deep .v-input--checkbox .v-messages {
    display: none;
}
</style>